import {Sequence} from 'components/Sequence';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import {PolymerTabState, PolymerTabStateAttributes} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

export type HistoryTabStateAttributes<Polymer extends AaSequence | Sequence> =
  PolymerTabStateAttributes<Polymer>;

interface HistoryTabState<Polymer extends AaSequence | Sequence> {
  get<K extends keyof HistoryTabStateAttributes<Polymer>>(key: K): HistoryTabStateAttributes<Polymer>[K];
  set<K extends keyof HistoryTabStateAttributes<Polymer>>(
    attributeName: K,
    value: HistoryTabStateAttributes<Polymer>[K],
    options?: Backbone.ModelSetOptions
  ): HistoryTabState<Polymer>;
  set(obj: Partial<HistoryTabStateAttributes<Polymer>>): HistoryTabState<Polymer>;
}

class HistoryTabState<Polymer extends AaSequence | Sequence> extends PolymerTabState<Polymer> {
  override defaults(): TabStateDefaults {
    return super.defaults();
  }
}

export default HistoryTabState;
